import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Breadcrumb, { BreadCrumbSeparator } from '@/components/common-components/Breadcrumb/Breadcrumb';

import CustomCompoundDatePicker from '../../common-components/CustomCompoundDatePicker/CustomCompoundDatePicker';
import HeaderComponent from '../../common-components/HeaderComponent/HeaderComponent';
import MainFallbackLoader from '../../common-components/Loaders/MainFallbackloader';
import CalendarIcon from '../../Icons/icons/CalendarIcon';
import SettingsIcon from '../../Icons/icons/SettingsIcon';
import AppliedChipSection from './components/CampaignDetails/AppliedChipSection';
import CampaignDetailProvider, { useCampaignDetail } from './components/CampaignDetails/CampaignDetailProvider';
import ContentGridSection from './components/CampaignDetails/ContentGridSection';
import ContentListSection from './components/CampaignDetails/ContentListSection/ContentListSection';
import ViewSelect from './components/CampaignDetails/CustomDetailHeader/ViewSelect';
import LabellingModal from './components/CampaignDetails/Labelling/LabellingModal';
import CreateEditLibraryModal from './components/Library/CreateEditLibraryModal';
import SocialListeningHeader from './components/SocialListeningHeader';

const LibraryDetailChild = () => {
  const [isEditSettingModal, setEditSettingModal] = useState(false);
  const { state } = useLocation();
  const {
    selectedDays,
    setSelectedDays,
    setDateRange,
    dateRange,
    selectedView,
    labelModalOpen,
    loadingContent,
    setLabelModalOpen,
  } = useCampaignDetail();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [library, setLibrary] = useState(state);
  const navigate = useNavigate();

  const { clearAllContentFilters } = useCampaignDetail();

  const maxDate = useMemo(() => {
    return new Date();
  }, []);

  const renderContent = () => {
    if (loadingContent) {
      return <MainFallbackLoader />;
    }
    return (
      <div className="mt-6">
        {selectedView === 'grid' ? (
          <ContentGridSection />
        ) : (
          <ContentListSection tableHeadStyle={{ top: '125px', position: 'sticky' }} />
        )}
        {labelModalOpen?.post && <LabellingModal labelModalOpen={labelModalOpen} setOpenModal={setLabelModalOpen} />}
      </div>
    );
  };

  return (
    <div className="sl-campaign-detail-container">
      <HeaderComponent
        style={{ position: 'sticky', top: 0, zIndex: 12 }}
        title={
          <div className="center" style={{ height: '42px' }}>
            <Breadcrumb onClick={() => navigate('/dashboard/social/campaigns')}>PULSE</Breadcrumb>
            <BreadCrumbSeparator />
            <Breadcrumb onClick={() => navigate('/dashboard/social/libraries')}>Libraries</Breadcrumb>
            {library?.title && (
              <>
                <BreadCrumbSeparator />
                <Breadcrumb active>{library?.title}</Breadcrumb>
              </>
            )}
            <SettingsIcon onClick={() => setEditSettingModal(true)} style={{ marginLeft: '8px', cursor: 'pointer' }} />
          </div>
        }
        showSearchBar={false}
      />
      <SocialListeningHeader
        rightSection={
          <>
            <ViewSelect />
            <CustomCompoundDatePicker
              selectedDays={selectedDays}
              setSelectedDays={setSelectedDays}
              dateRange={dateRange}
              allowSingleDateInRage
              maxDate={maxDate}
              setDateRange={setDateRange}
              showDatePicker={showDatePicker}
              setShowDatePicker={setShowDatePicker}
              containerStyle={{ color: 'var(--text-default)' }}
              customCalenderIcon={<CalendarIcon />}
            />
          </>
        }
      />
      {isEditSettingModal && (
        <CreateEditLibraryModal
          library={library}
          setLibrary={setLibrary}
          show={isEditSettingModal}
          mode="edit"
          onClose={() => setEditSettingModal(false)}
          onSuccess={clearAllContentFilters}
        />
      )}
      <div className="sl-campaign-detail-content">
        <AppliedChipSection />
        {renderContent()}
      </div>
    </div>
  );
};

const LibraryDetail = () => {
  return (
    <CampaignDetailProvider
      defaultActiveTab="content"
      apiConfig={{
        getCampaignDetails: false,
        getStats: false,
        getUsageRights: false,
        postsApiMode: 'library',
      }}>
      <LibraryDetailChild />
    </CampaignDetailProvider>
  );
};

export default LibraryDetail;
